<template>
  <ActionButton :action-url="actionUrlWithParams" :size="size" class="action-button">
    <template #action-button-text>
      {{ i18n.t(textI18nKey) }}
    </template>
  </ActionButton>
</template>

<script>
import { mapGetters } from 'vuex'
import ActionButton from '../components/buttons/action-button'
import { actionUrlWithParamsMixin } from './action-url-with-params'

export default {
  components: { ActionButton },

  mixins: [ actionUrlWithParamsMixin ],

  props: {
    textI18nKey: {
      type: String,
      default: 'local_chapters.upcoming_events.create_event'
    },
    size: {
      type: String,
      default: null
    }
  },

  computed: {
    ...mapGetters(['newEventPath']),

    actionUrl() {
      return `${window.location.origin}${this.newEventPath}`
    }
  }
}
</script>
